import { Component, OnInit } from '@angular/core';
import { ExtraService } from '../../core/services/extra.service';
import { UtilityService } from '../../core/services/utility.service';
import { Router } from '@angular/router';
import { ProfileService } from '../../core/services/profile.service';
import { AuthService } from '../../core/services/auth.service';
import { Constants } from '../../core/config/Constants';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  providers:[ExtraService,ProfileService,AuthService]
})
export class HeaderComponent implements OnInit {
 
  //isCollapsed: boolean = false; 
  isShow :boolean;
  name:string;
  profileImageUri: string = 'assets/img/avatar-4.jpg';
  constructor(private authService:AuthService,private router: Router,private utilityService: UtilityService,private extraService:ExtraService,private profileService:ProfileService) { 
    this.setUserName();
  }
  ngOnInit() {
    this.extraService.castSideBarButton$.subscribe(isShow=>{
      setTimeout(()=>{
        this.isShow = isShow;
      });
    });
  }
  setUserName(){
    this.profileService.getUserProfile().subscribe(item=>{
      if(item){
        this.name = item.name;
        if(item.profileImageUri){
          this.profileImageUri = item.profileImageUri;
        }
      }
    });
  }
  logout(){
    console.log('logout');
    this.authService.logout();
    this.utilityService.logout();
    this.extraService.changeStateLogin();
    this.extraService.changeSideBar(false);
    this.router.navigate([Constants.LOGIN_URL]);
  }
  change(){
    this.extraService.changeStateofSideBar();
  }
  collapsed(event: any): void {
    console.log(event);
  } 
  expanded(event: any): void {
    console.log(event);
  }
}



// WEBPACK FOOTER //
// /app/src/app/layout/header/header.component.ts